module.exports = __webpack_public_path__ + "static/media/img-heritage-area8-ongagawa.c86c244b.jpg";